// Reiter der Gesamtübersicht filtern nur Produkte aus ihren realen Kollektionen.
let selected = 'haus-garten';
function applySelection() {
  const root = document.querySelector('.starhome-collection-overview');
  const nav = root?.querySelector('.sh-vordach-type-tabs');
  if (!root || !nav) return;
  let visible = 0;
  root.querySelectorAll('li[data-sh-vordach-item]').forEach(card => {
    const show = selected === 'haus-garten' || (card.dataset.shVordachTypes || '').split(' ').includes(selected);
    if (card.hidden === show) card.hidden = !show;
    if (show) visible++;
  });
  nav.querySelectorAll('a').forEach(link => {
    const active = new URL(link.href).pathname === '/collections/' + selected;
    if (active) { if (!link.hasAttribute('aria-current')) link.setAttribute('aria-current', 'page'); }
    else if (link.hasAttribute('aria-current')) link.removeAttribute('aria-current');
  });
  root.querySelectorAll('.products-count-wrapper span').forEach(counter => {
    const text = visible + ' Artikel';
    if (counter.textContent !== text) counter.textContent = text;
  });
}
document.addEventListener('click', event => {
  const link = event.target.closest?.('.sh-vordach-type-tabs a');
  if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const url = new URL(link.href);
  if (url.origin !== location.origin) return;
  event.preventDefault();
  event.stopPropagation();
  selected = url.pathname.split('/').filter(Boolean).pop();
  applySelection();
}, { capture: true });
function initialize() {
  applySelection();
  const root = document.querySelector('.starhome-collection-overview')?.closest('.shopify-section');
  if (root) new MutationObserver(() => applySelection()).observe(root, { childList: true, subtree: true });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
else initialize();
